import React from 'react';
import { getApiBase } from '../apiBase';

const REPLY_EXAMPLES = [
  'So glad we could help — the best compliment is telling your friends & family about us! 🙂',
  "Thank you so much! If you know anyone who needs us, we'd love the referral.",
  'Made our day — please spread the word to friends & family!',
];

export default function ReviewsPanel({ ownerId, onClose }) {
  const STORE_KEY = `howto_reviews_connected_${ownerId || 'me'}`;
  const [connected, setConnected] = React.useState(false);
  const [count, setCount] = React.useState(0);

  React.useEffect(() => {
    try {
      setConnected(localStorage.getItem(STORE_KEY) === '1');
    } catch (_) {}
  }, [STORE_KEY]);

  React.useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${getApiBase()}/api/reviews/summary?ownerId=${encodeURIComponent(ownerId || '')}`);
        if (!res.ok) return;
        const data = await res.json();
        if (!alive) return;
        if (typeof data?.replied === 'number') setCount(Math.round(data.replied));
        if (data?.connected) {
          setConnected(true);
          try { localStorage.setItem(STORE_KEY, '1'); } catch (_) {}
        }
      } catch (_) {}
    })();
    return () => { alive = false; };
  }, [ownerId, STORE_KEY]);

  const connect = React.useCallback(() => {
    try { localStorage.setItem(STORE_KEY, '1'); } catch (_) {}
    setConnected(true);
    window.open('https://business.google.com/', '_blank');
  }, [STORE_KEY]);

  return (
    <div className="agent-detail" onClick={onClose}>
      <div className="agent-detail__panel" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="agent-detail__close" onClick={onClose} aria-label="Close">×</button>
        <div className="agent-detail__title">Reviews</div>
        <div className="agent-detail__cadence">Ongoing</div>
        <p className="agent-detail__desc">
          Aria watches your Google reviews and replies to each one — warm, a little different every time,
          always inviting them to tell friends &amp; family.
        </p>

        {connected && count > 0 ? (
          <div className="agent-detail__status">✓ Aria has replied to {count.toLocaleString()} review{count === 1 ? '' : 's'}</div>
        ) : null}

        <div className="agent-detail__section">How Aria replies</div>
        <div className="sched-events">
          {REPLY_EXAMPLES.map((text, i) => (
            <div className="sched-event" key={i}>
              <div className="sched-event__t" style={{ fontWeight: 500, lineHeight: 1.45 }}>{text}</div>
              <div className="sched-event__m">Example reply #{i + 1} — never the same twice</div>
            </div>
          ))}
        </div>

        {!connected ? (
          <>
            <div className="sched-warn" style={{ marginTop: 14 }}>
              Replying to Google reviews needs your Google Business Profile connected.
            </div>
            <button type="button" className="agent-detail__cta" onClick={connect}>Connect Google Business</button>
          </>
        ) : (
          <div className="sched-ok" style={{ marginTop: 14 }}>✓ Google Business connected — Aria is replying automatically.</div>
        )}

        <div className="agent-detail__note">Once connected, Aria replies automatically, never copy-paste.</div>
      </div>
    </div>
  );
}
